
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./DailyReport": () => {
return Promise.all(/*  | __federation_expose_DailyReport */ [__webpack_require__.e("568"), __webpack_require__.e("161"), __webpack_require__.e("187"), __webpack_require__.e("734")]).then(() => (() => (__webpack_require__(351))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };